import { useReactiveVar } from "@apollo/client";
import React from "react";
import { currentSport } from "src/services/ApolloService";

type PlayerCardNameProps = {
  children?: any;
  className?: string;
};

export const PlayerCardName = ({ className = "", children }: PlayerCardNameProps) => {
  const sport = useReactiveVar(currentSport);
  return sport?.hasPlayerCards ? (
    <a className={`${className}`}>{children}</a>
  ) : (
    <div className={`${className}`}>{children}</div>
  );
};
